import * as $ from 'jquery';
import { Component, OnInit, Inject, ViewChild, AfterViewInit, ElementRef, OnDestroy } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { serviceUrl } from '../common/serviceconstants';
import { Router, ActivatedRoute } from '@angular/router';
import { GenericHttpClient } from '../Services/Basicauthentication';
import { UtilityServices } from '../UtilityServices';
import { ProgressBarMode } from '@angular/material/progress-bar';
import { ThemePalette } from '@angular/material/core';
import { CurrencyPipe } from '@angular/common'
import { EmitterService } from '../emitterservice';
@Component({
  selector: 'app-global-dashboard',
  templateUrl: './global-dashboard.component.html',
  styleUrls: ['./global-dashboard.component.css']
})
export class GlobalDashboardComponent implements OnInit {
  color: ThemePalette = 'primary';

  InfraCount: any = 0;
  PublicSafetyCount: any = 0;
  ProjectsPlanningCount: any = 0;
  ProjectsDesignCount: any = 0;
  ProjectsConstructionCount: any = 0;
  ProjectsHoldCount: any = 0;
  ProjectsNotFeasibleCount: any = 0;
  ProjectsCompletedCount: any = 0;
  ProjectsFutureCount: any = 0;
  TotalProjectsCount: any = 0;
  PendingProjectCount: any = 0;
  TotalCIPBudgetAmount: any = 0;

  mode: ProgressBarMode = 'determinate';

  constructor(private http: HttpClient, private router: Router, private httpClient: GenericHttpClient, private cp: CurrencyPipe) {
    this.GetDashboardContentInfo();
    EmitterService.get('publish').subscribe(res => {
      //this.GetDashboardContentInfo();
      window.location.reload();
    })
    EmitterService.get('delete').subscribe(res => {
      //this.GetDashboardContentInfo();
      window.location.reload();
    })
  }

  getPlanningLeft() {
    return (((this.ProjectsPlanningCount / this.TotalProjectsCount) * 100).toFixed(0)) + '%';
  }

  getDesignLeft() {
    return ((this.ProjectsDesignCount / this.TotalProjectsCount) * 100).toFixed(0) + '%';
  }

  getConstructionLeft() {
    return ((this.ProjectsConstructionCount / this.TotalProjectsCount) * 100).toFixed(0) + '%';
  }

  getCompletedLeft() {
    return ((this.ProjectsCompletedCount / this.TotalProjectsCount) * 100).toFixed(0) + '%';
  }

  getFututeLeft() {
    return ((this.ProjectsFutureCount / this.TotalProjectsCount) * 100).toFixed(0) + '%';
  }


  GetDashboardContentInfo(): void {
    this.httpClient.get(serviceUrl + '/Project/GetAllDashboardInfo',
      '').toPromise<any>().then(response => {
        this.InfraCount = response.InfrastructureProjects;
        this.PublicSafetyCount = response.PublicSafetyProjects;
        this.ProjectsPlanningCount = response.ProjectsinPlanning;
        this.ProjectsDesignCount = response.ProjectsinDesign;
        this.ProjectsConstructionCount = response.ProjectsinConstruction;
        this.ProjectsHoldCount = response.ProjectsinHold;
        this.ProjectsNotFeasibleCount = response.ProjectsinNotFeasible;
        this.ProjectsCompletedCount = response.ProjectsinCompleted;
        this.PendingProjectCount = response.PendingProjects;
        this.ProjectsFutureCount = response.ProjectsinFuture;
        //this.TotalCIPBudgetAmount = response.TotalCIPBudgetAmount;
        this.TotalCIPBudgetAmount = this.cp.transform(response.TotalCIPBudgetAmount, 'USD', 'symbol', '1.2-2');
        this.TotalProjectsCount = response.TotalProjects;
      });
  }





  public doughnutChartLabels: string[] = ['INFRASTRUCTURE PROJECTS', 'PUBLIC SAFETY PROJECTS'];
  public demodoughnutChartData: number[] = [350, 450];
  public doughnutChartType: string = 'doughnut';

  // events
  public chartClicked(e: any): void {
    console.log(e);
  }

  public chartHovered(e: any): void {
    console.log(e);
  }


  chartOptions = {
    responsive: true,
    rotation: 1 * Math.PI,
    circumference: 1 * Math.PI
  };
  chartData = [
    {
      data: [70, 30], label: 'Completed', backgroundColor: [
        "#a5d1fc",
        "#eee"
      ],
    }
  ];
  chartLabels = ['Completed', 'Remaining'];




  ngOnInit() {
    $('.project-slider').on('slide.bs.carousel', function (e) {
      let $e = $(e.relatedTarget),
        itemsPerSlide = 3,
        totalItems = $('.carousel-item', this).length,
        $itemsContainer = $('.carousel-inner', this),
        it = itemsPerSlide - (totalItems - $e.index());
      if (it > 0) {
        for (var i = 0; i < it; i++) {
          $('.carousel-item', this).eq(e.direction == "left" ? i : 0).
            // append slides to the end/beginning
            appendTo($itemsContainer);
        }
      }
    });
  }

}
